import type { storeAddressInterface } from '@/types/store'
import type { BrandAppShowcaseStore } from './brandAppContract'

export const storeStreet = (address: Partial<storeAddressInterface>) =>
  [address.streetNumber, address.streetNumberSupplement, address.streetType, address.streetName]
    .filter(Boolean)
    .join(' ')
    .trim()

export const withStoreAddress = (
  store: BrandAppShowcaseStore,
  address: Partial<storeAddressInterface> | null | undefined
): BrandAppShowcaseStore => {
  if (!address) return store
  const street = storeStreet(address)
  const city = address.city?.trim() ?? ''
  const zip = address.zipCode?.trim() ?? ''

  return {
    ...store,
    address: street ? [street, [zip, city].filter(Boolean).join(' ')].filter(Boolean).join(', ') : undefined,
    city: city || undefined
  }
}
